import Script from "next/script";

const GPTCriteoScript = () => {
  const html = `
    window.Criteo = window.Criteo || {};
    window.Criteo.events = window.Criteo.events || [];
  `;

  return (
    <>
      <Script
        async="async"
        type="text/javascript"
        src="https://static.criteo.net/js/ld/publishertag.js"
        strategy="afterInteractive"
        id="criteo-publisher-tag"
      />
      <Script
        id="criteo-events"
        strategy="afterInteractive"
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </>
  );
};

export default GPTCriteoScript;
